import { useAxios, getQueryKey } from '@flex-packages/remote-hooks';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import '../../apis/workspace/apis/workspace-customer-controller-api.mjs';
import { getMyWorkspaceUsersRemote } from '../../apis/workspace/apis/workspace-user-controller-api.mjs';
import '../../apis/workspace/apis/workspace-user-customer-controller-api.mjs';

const useMyUserInfo = (options) => {
  const { instances } = useAxios();
  const [getMyWorkspaceUsersAPI, defaultConfig] = getMyWorkspaceUsersRemote(
    instances.json
  );
  const queryKey = getQueryKey(defaultConfig);
  const getMyWorkspaceUsers = useCallback(async () => {
    const { data } = await getMyWorkspaceUsersAPI();
    return data;
  }, [getMyWorkspaceUsersAPI]);
  return useQuery({
    queryKey,
    queryFn: getMyWorkspaceUsers,
    ...options,
    staleTime: options?.staleTime ?? Infinity,
    cacheTime: options?.cacheTime ?? Infinity
  });
};

export { useMyUserInfo as default };
//# sourceMappingURL=useMyUserInfo.mjs.map
